import { render, staticRenderFns } from "./ym-cost-page.vue?vue&type=template&id=5293c75b&scoped=true&"
import script from "./ym-cost-page.vue?vue&type=script&lang=js&"
export * from "./ym-cost-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293c75b",
  null
  
)

export default component.exports